/**
 * Shared limits for a dietary-accommodation note upload.
 *
 * Lives HERE, not in `@ordo/schema`, because both a browser and a server need
 * them: the file picker's `accept`, the pre-send size check, and the server's
 * own validation. `@ordo/constants` has no runtime dependencies, so a client
 * bundle can import it — importing them from `@ordo/schema` instead pulls the
 * generated Prisma client (and `node:path` / `node:crypto`) into the browser
 * build, which is a build failure, not a warning.
 *
 * The enforcement that matters still lives server-side in
 * `@ordo/schema`'s `parseDoctorNoteUpload`, which sniffs the bytes. These are
 * the numbers both sides agree on, never the check itself.
 */

/** 10 MB decoded. A phone photo of a note is ~2-5 MB; a scan is smaller. */
export const DOCTOR_NOTE_MAX_BYTES = 10 * 1024 * 1024

/** The types the server will accept once it has sniffed the bytes. */
export const DOCTOR_NOTE_CONTENT_TYPES = ['application/pdf', 'image/jpeg', 'image/png'] as const

export type DoctorNoteContentType = (typeof DOCTOR_NOTE_CONTENT_TYPES)[number]

/**
 * The `accept` attribute for a note file input, kept next to the allowlist so
 * a picker can never offer a type the server then rejects. Extensions rather
 * than MIME types because browsers match those more reliably — and it is a
 * HINT either way, since the server sniffs.
 */
export const DOCTOR_NOTE_FILE_ACCEPT = '.pdf,.jpg,.jpeg,.png'
